import msgApi from '@/api/msg'

const msg={
  namespaced:true,
  state:{
    data:[null],
    loading:false,
    editMsg:{},
    sorter:{},
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,data)=>{
      state.editMsg=data
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    }
  },
  actions:{
    async GetAll({ commit }){
      commit('setLoading',true)
      const page={
        skipCount:0,
        maxResultCount:10000000
      }           
      try{
        const res=await msgApi.getAll(page)
        const datas=[null]
        datas.push(...res.result.items)
        commit('setData',datas)
      }finally {
        commit('setLoading',false)
      }
    },
    async GetAllMsg({commit}){
      commit('setLoading',true)
      const page={
        skipCount:0,
        maxResultCount:10000000
      }           
      try{
        const res=await msgApi.getAll(page)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch },msg){
      try{
        if(msg.id){
          await msgApi.update(msg)          
        }else{
          await msgApi.create(msg)
        }
        commit('edit',{})
        await dispatch('GetAll')
      }catch(err){
        throw err
      }     
    },
    async Delete({ dispatch },id){
      await msgApi.delete(id)
      await dispatch('GetAll')
    }
  }
}
export default msg